export default __webpack_public_path__ + "static/media/front-sprocket-protector.1442e10b.jpg";